<template>
  <section class="payment_sec h-100">
    <div class="container h-100">
      <div class="row h-100">
        <div class="col-lg-4 m-auto">
          <div class="payment_box">
            <a class="logonew" href="#"><img :src="`${publicPath}images/logo.svg`"></a>
            <div class="successpay">
              <lottie-player :src="`${publicPath}app-assets/downloaded-cdn/lottie-player-success.json`" background="transparent"
                             speed="1" style="width: 300px; height: 300px;" autoplay></lottie-player>
              <p>Transaction has been successful<br><span v-if="txnId != ''" class="text-success">#{{ txnId }}</span>
              </p>
            </div>
            <div class="ammountsec text-center">
<!--              <button class="nextbtn paynowbtn btn" @click="$router.go(-1)">Back</button>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div v-show="loader" class="blockUI" style="display:none"></div>
  <div v-show="loader" class="blockUI blockOverlay"
       style="z-index: 1000; border: none; margin: 0px; padding: 0px; width: 100%; height: 100%; top: 0px; left: 0px; background-color: rgb(0, 0, 0); opacity: 0.5; cursor: wait; position: fixed;"></div>
  <div v-show="loader" class="blockUI blockMsg blockPage"
       style="z-index: 1011; position: fixed; padding: 0px; margin: 0px; width: 30%; top: 40%; left: 35%; text-align: center; color: rgb(255, 255, 255); border: 0px; background-color: transparent; cursor: wait;">
    <div class="d-flex justify-content-center align-items-center"><p class="mr-50 mb-0">Please wait you being
      redirected...</p>
      <div class="spinner-grow spinner-grow-sm text-white" role="status"></div>
    </div>
  </div>
</template>

<script>
export default {
  // created() {
  //   setTimeout(() => {window.history.forward()},0)
  //   window.onunload = function () { null };
  // },
  mounted() {
    // history.pushState(null, null, window.location.href);
    // history.back();
    // window.onpopstate = () => history.forward();
    // setTimeout(() => {window.history.forward()},0)
    // window.onunload = function () { null };
    this.txnId = typeof (this.$route.query.txnId) != 'undefined' ? this.$route.query.txnId : ''
    let res = typeof (this.$route.query.res) != 'undefined' ? this.$route.query.res : null
    if (res) {
      res = this.baseDecoder(res)
      this.txnId = res['txnId']
      this.redirectUrl = res['redirectUrl']
      // console.log(this.txnId, this.redirectUrl)
      if (this.redirectUrl && this.redirectUrl != '') {
        setTimeout(() => {
          this.loader = true
          setTimeout(() => {
            this.loader = false
            window.location.replace(this.redirectUrl)
            // window.open(this.redirectUrl,
            //     'newwindow',
            //     'width=300,height=250');
          }, 3000)
        }, 3000)
        return

      }

    }

    let paymentData = typeof (localStorage.getItem('transaction-payment-details')) != "undefined" ? JSON.parse(localStorage.getItem('transaction-payment-details')) : null
    if (paymentData) {
      localStorage.setItem('transaction-payment-details', null)
      if (typeof (paymentData.redirectUrl) != "undefined" && paymentData.redirectUrl != '' && paymentData.redirectUrl) {
        setTimeout(() => {
          this.loader = true
          setTimeout(() => {
            this.loader = false
            // window.open(paymentData.redirectUrl,
            //     'newwindow',
            //     'width=300,height=250');
            window.location.replace(paymentData.redirectUrl)
          }, 3000)
        }, 3000)

      }
    }
  },
  data() {
    return {
      txnId: '',
      loader: false,
      redirectUrl: ''
    }
  },
}
</script>

